/* tslint:disable */
/* eslint-disable */
/**
 * Poolside API
 * Poolside API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiCreateAdminRequest,
    ApiCreateAdminRequestFromJSON,
    ApiCreateAdminRequestFromJSONTyped,
    ApiCreateAdminRequestToJSON,
    CompanyData,
    CompanyDataFromJSON,
    CompanyDataFromJSONTyped,
    CompanyDataToJSON,
} from './';

/**
 * data required to create a company or fund
 * @export
 * @interface ApiCreateCompanyRequest
 */
export interface ApiCreateCompanyRequest {
    /**
     * 
     * @type {CompanyData}
     * @memberof ApiCreateCompanyRequest
     */
    companyData: CompanyData;
    /**
     * 
     * @type {Array<ApiCreateAdminRequest>}
     * @memberof ApiCreateCompanyRequest
     */
    representatives: Array<ApiCreateAdminRequest>;
}

export function ApiCreateCompanyRequestFromJSON(json: any): ApiCreateCompanyRequest {
    return ApiCreateCompanyRequestFromJSONTyped(json, false);
}

export function ApiCreateCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiCreateCompanyRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyData': CompanyDataFromJSON(json['companyData']),
        'representatives': ((json['representatives'] as Array<any>).map(ApiCreateAdminRequestFromJSON)),
    };
}

export function ApiCreateCompanyRequestToJSON(value?: ApiCreateCompanyRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyData': CompanyDataToJSON(value.companyData),
        'representatives': ((value.representatives as Array<any>).map(ApiCreateAdminRequestToJSON)),
    };
}

